// Generated by CoffeeScript 1.12.7
(function() {
  var hasProp = {}.hasOwnProperty;

  module.exports = function() {
    var argument, i, key, len, ref, value;
    ref = Array.prototype.slice.call(arguments, 1);
    for (i = 0, len = ref.length; i < len; i++) {
      argument = ref[i];
      if (argument != null) {
        for (key in argument) {
          if (!hasProp.call(argument, key)) continue;
          value = argument[key];
          arguments[0][key] = value;
        }
      }
    }
    return arguments[0];
  };

}).call(this);
